import { useEffect, useState } from 'react'
import PanelGambar, { bentukUbah, catatHasil } from './PanelGambar'
import {
  useBuatGambar, useBuatPromptGambar, useBuatTeks, useBuatVideo, useUbahGambar,
  useReferensi,
  useHapusKonten, useJadwalkanKonten, useSegarkanInsight, useSimpanSlide,
  useUbahTeksKonten,
  useUnggahGambarKonten,
 
} from '../../../domains/content/api'
import { useModelTenant } from '../../../domains/tenancy/api'
import { bentukBahan, refBawaan } from '../../../shared/lib/referensi'
import { modelUntukJenis } from './BuatKonten'
import { istilah } from '../../../shared/lib/istilah'
import { adaAngka, angka, sejak, tanggalJam, waktuUntukIsian }
  from '../../../shared/lib/waktu'
import {
  AreaTeks, Baris, Bendera, Body, Chip, Gambar, Isian, KV, KVBaris, KepalaHalaman,
  Kolom2, Panel, Seg, Sub, Tabel, Tombol, TombolBuat,
} from '../../../shared/ui'
import { NADA, angkaAtauKosong, jelaskanGagal, singkatPlatform } from './Konten'
import { bacaHashtag } from '../../../domains/content/tampil'

export { bacaHashtag } from '../../../domains/content/tampil'


/**
 * Apakah konten ini DRAFT yang belum punya jalan keluar.
 *
 * Draft punya `scheduled_at` — kolomnya NOT NULL — tapi tidak punya jalan untuk
 * MENGAKTIFKANNYA: `publish_due` hanya memilih `scheduled`, `review_item` menolak apa pun
 * yang bukan `pending_approval`. Ia duduk di "Akan tayang" dengan tanggal yang terlihat
 * sah, dan tidak pernah terbit.
 *
 * Diperiksa atas SELURUH tujuan, seperti `bisaSuntingMedia`: satu tujuan yang sudah
 * terjadwal sementara yang lain masih draft berarti separuhnya sudah lepas, dan
 * menjadwalkan ulang seluruhnya akan memindahkan yang sudah lepas itu juga.
 */
export function draftBelumTerjadwal(k) {
  const baris = k?._anak ?? (k ? [k] : [])
  return baris.length > 0 && baris.every((a) => a.status === 'draft')
}

/**
 * Konten buatan orang yang MENUNGGU dan belum punya jam (R11, 29 September).
 *
 * Sistem tidak memilihkan jam untuk konten yang dibuat orang; jamnya dipilih di sini atau
 * lewat 📅 Jadwalkan di kartu Telegram. "Setujui" tanpa jam ditolak rutenya, karena
 * konten terjadwal tanpa jam tidak pernah diambil penerbit.
 */
export function menungguTanpaJam(k) {
  const baris = k?._anak ?? (k ? [k] : [])
  return baris.length > 0
    && baris.every((a) => a.status === 'pending_approval' && !a.scheduled_at)
}

/**
 * Slide yang sekarang -> bentuk yang dimengerti `PanelGambar`.
 *
 * DISEMAI DARI YANG ADA, bukan dari daftar kosong. Panel yang terbuka kosong terbaca
 * sebagai "gambarnya hilang", dan orang yang menekan Simpan di situ membuang gambar yang
 * sudah ada tanpa bermaksud begitu — kerusakan yang tidak bisa dibatalkan, karena
 * gambar lamanya tidak disimpan di mana pun lagi.
 *
 * `prompt` sengaja kosong: arahan yang dipakai draft aslinya tidak tersimpan di baris
 * antrean, dan menebaknya dari caption akan menampilkan arahan yang TIDAK menghasilkan
 * gambar itu — lebih menyesatkan daripada kotak kosong.
 */
export function semaiDraf(slide) {
  return (slide ?? []).filter(Boolean).map((u) => ({ prompt: '', url: u, biaya: null }))
}

/**
 * Judul pendek untuk kepala halaman detail.
 *
 * Bentuk lamanya `k.caption || k.topic` — dan urutan itu terbalik. `caption` adalah
 * caption Instagram UTUH, sampai 1800 karakter lengkap dengan emoji dan ajakan
 * bertindak; ia dipakai sebagai judul sebesar 21px dan memenuhi seperempat layar
 * sebelum satu pun panel terlihat. `topic` justru yang berbentuk judul — di jalur
 * automation ia diisi judul trennya sendiri.
 *
 * TIDAK ADA YANG HILANG: caption penuh tetap tampil apa adanya di panel Caption di
 * bawahnya. Yang dipotong cuma yang di kepala.
 *
 * Dipotong di BATAS KATA, bukan di tengah kata: "Menkes Dorong Pembia…" terbaca seperti
 * data yang rusak, sedangkan "Menkes Dorong…" terbaca seperti judul yang dipendekkan.
 *
 * MURNI, supaya bisa diuji tanpa merender apa pun.
 */
export function judulKonten(k, t, batas = 72) {
  const mentah = String(k?.topic || k?.caption || "").trim()
  if (!mentah) return t ? t('konten.tanpaJudul') : ''
  // Baris pertama saja: caption berbaris-baris, dan baris kedua dan seterusnya adalah
  // hashtag atau ajakan bertindak — bukan judul.
  let teks = mentah.split('\n')[0].trim()
  if (teks.length <= batas) return teks
  const potong = teks.slice(0, batas)
  const spasi = potong.lastIndexOf(' ')
  // Kalau tidak ada spasi sama sekali dalam batas itu (satu kata sangat panjang),
  // dipotong apa adanya — lebih baik daripada mengembalikan string kosong.
  teks = spasi > batas * 0.5 ? potong.slice(0, spasi) : potong
  return `${teks.replace(/[\s,.;:—-]+$/, '')}…`
}

/**
 * Apakah media konten ini masih boleh diubah.
 *
 * Yang sudah `published` TIDAK: gambarnya sudah ada di Instagram, dan mengganti barisnya
 * di sini cuma membuat catatan kita berbeda dari yang dilihat orang. Yang `rejected` juga
 * tidak — ia sudah dibuang, dan menyuntingnya menghidupkan kembali sesuatu yang sengaja
 * dimatikan.
 *
 * Diperiksa atas SELURUH tujuan, bukan cuma baris pertama: kalau Instagram sudah terbit
 * sementara Facebook masih menunggu, mengganti gambarnya berarti kedua unggahan yang
 * seharusnya kembar jadi berbeda.
 *
 * MURNI, karena panel penyuntingnya cuma dirender kalau ini true — dan uji render tidak
 * bisa mengklik apa pun untuk mengubah statusnya (XXIII-1).
 */
// Gaya <Tombol jenis="sekunder" kecil> untuk elemen yang BUKAN tombol — sebuah <label>
// yang menyembunyikan <input type="file"> di dalamnya. Disalin, bukan dibungkus:
// <button> tidak bisa membuka pemilih berkas tanpa JavaScript tambahan.
const GAYA_UNGGAH =
  'font-semibold rounded border cursor-pointer text-[11px] px-2 py-1 '
  + 'bg-surface text-ink2 border-lineStrong hover:text-ink hover:border-ink3'

const _BOLEH_SUNTING = ['pending_approval', 'draft', 'failed']

export function bisaSuntingMedia(k) {
  const baris = k?._anak ?? (k ? [k] : [])
  if (!baris.length) return false
  return baris.every((a) => _BOLEH_SUNTING.includes(a.status))
}

/**
 * DETAIL SATU KONTEN — mengikuti rancangan 7 September.
 *
 * @layar-penuh — MENGGANTIKAN halaman Konten, bukan dirender di bawah bilah tabnya.
 * Induknya `return` lebih awal saat sebuah baris dibuka, jadi yang terender cuma satu
 * dari keduanya dan jumlah <KepalaHalaman> saat dirender tetap satu. Tanpa penanda ini
 * `periksa_judul` menghitungnya sebagai judul kedua — benar untuk tab, salah untuk ini.
 *
 * Dua kolom: kiri Insight + Caption, kanan "Yang tayang". Menggantikan seluruh layar,
 * bukan panel yang menyembul di bawah tabel — isinya panjang, dan menaruhnya di bawah
 * daftar berarti orang menggulir melewati tabel tiap kali lalu kehilangan tempatnya.
 *
 * PEMILIH PLATFORM DI KEPALA PANEL INSIGHT, dan itu yang membuat halaman ini benar.
 *
 * Rancangan menulis "gabungan semua platform" di catatan panelnya, TAPI catatan kaki di
 * bawahnya membatalkannya sendiri: *"saat platform kedua menyusul, angka ini harus
 * dipisah per platform: jangkauan Instagram dan Facebook tidak bisa dijumlahkan begitu
 * saja, karena satu orang yang melihat di keduanya terhitung dua kali."*
 *
 * Platform kedua sudah menyusul — Facebook terbit sejak 11 September. Jadi yang dipakai
 * kalimat keduanya: satu platform dipilih, angkanya angka platform itu. Tidak ada
 * penjumlahan di mana pun, dan tidak ada satu angka pun yang harus dibaca sebagai "kira-
 * kira segini".
 */
/**
 * Tujuan mana yang angkanya sedang ditampilkan panel Insight.
 *
 * DIPISAH DARI KOMPONENNYA SUPAYA BISA DIUJI. Pemilih platformnya adalah state React
 * yang cuma berubah karena klik, dan `renderToString` tidak bisa mengklik apa pun
 * (XXIII-1) — jadi uji render selalu melihat platform pertama. Akibatnya cacat "panel
 * memakai anak pertama, bukan yang dipilih" lolos sepenuhnya: keluaran awalnya identik.
 * Terbukti lewat kontrol negatif 12 September, satu-satunya suntikan yang tidak
 * tertangkap. Yang di bawah ini logikanya, dan `uji_detail.mjs` yang mengujinya.
 *
 * Jatuh ke tujuan pertama kalau tidak ada yang cocok — halaman tanpa angka sama sekali
 * lebih buruk daripada halaman yang menampilkan tujuan lain, dan pemilihnya menyebut
 * mana yang sedang aktif.
 */
export function pilihTujuan(anak, platform) {
  return anak.find((a) => (a.platform || 'instagram') === platform) || anak[0]
}

/**
 * Slide ke berapa sesudah ditekan maju/mundur.
 *
 * DIJEPIT DI KEDUA UJUNG, tidak berputar. Collase punya urutan yang berarti — slide
 * pertama yang muncul di feed — jadi "sesudah yang terakhir kembali ke yang pertama"
 * menghapus satu-satunya petunjuk bahwa Anda sudah sampai ujung. Tombolnya dimatikan
 * di ujung, dan itu terlihat sebelum diklik.
 *
 * DIPISAH DARI KOMPONENNYA SUPAYA BISA DIUJI: nilainya cuma berubah karena klik, dan
 * `renderToString` tidak mengklik apa pun (XXIII-1) — uji render selamanya melihat
 * slide pertama. Alasan yang sama dengan `pilihTujuan` di atas.
 */
export function geserSlide(kini, arah, total) {
  const n = Math.max(0, Math.min(kini + arah, total - 1))
  return Number.isFinite(n) ? n : 0
}

export default function DetailKonten({ k, t, locale, onTutup }) {
  const anak = k._anak ?? [k]
  const [platform, setPlatform] = useState(anak[0]?.platform || 'instagram')
  const kini = pilihTujuan(anak, platform)
  // SLIDE COLLASE, dan `media_url` sebagai cadangan untuk konten satu gambar.
  //
  // Keduanya digabung dengan hati-hati: `media_urls` sudah MEMUAT gambar pertama untuk
  // collase, jadi menambahkan `media_url` di depannya akan menampilkan slide pertama
  // dua kali dan menggeser seluruh penomorannya.
  const slide = (k.media_urls ?? []).length ? k.media_urls : [k.media_url]
  const [slideKe, setSlideKe] = useState(0)
  const segarkan = useSegarkanInsight()
  const bisaSegarkan = kini?.status === 'published'

  // Tiga aksi media, SATU keadaan sibuk. Menjalankan dua sekaligus pada baris yang sama
  // berarti yang selesai belakangan menimpa yang duluan — dan yang menekannya melihat
  // gambar yang bukan hasil tombol terakhir yang ia tekan.
  // ── Penyunting gambar: KOMPONEN YANG SAMA dengan layar Buat Konten ───────
  //
  // Operator memintanya 14 September: "banyak fitur bagus yang dibutuhkan tenant
  // marketing". Yang dibawa ke sini bukan salinannya — `PanelGambar` memang sudah
  // menerima semuanya lewat prop, jadi model, referensi, prompt per slide, urutan, dan
  // biaya per slide datang apa adanya. Dua salinan panel gambar akan menyimpang dalam
  // hitungan minggu, dan yang paling mahal saat menyimpang adalah harga yang ditampilkan.
  //
  // BUKAN dengan pindah ke layar Buat Konten. Layar itu dibentuk untuk MEMBUAT: membuka
  // baris antrean di sana lalu menyimpan menghasilkan konten KEDUA untuk slot yang sama,
  // dan tidak ada yang menyadarinya sampai keduanya terbit.
  //
  // DRAFT DI SINI, TULIS SAAT SIMPAN. Tiap gambar yang dibuat atau diunggah cuma
  // menghasilkan URL; antreannya berubah sekali saja, di akhir. Itu yang membuat Batal
  // berarti sesuatu — kalau tiap langkah langsung menulis, "batal" tidak bisa
  // mengembalikan apa pun, dan orangnya baru tahu saat menekannya.
  const [sunting, setSunting] = useState(false)
  const [draf, setDraf] = useState([])
  const [model, setModel] = useState('')
  const [refDipakai, setRefDipakai] = useState([])
  const [refDisemai, setRefDisemai] = useState(false)
  // Gambar temporary: peta `temp:<n>` -> data URI. Tidak pernah tersimpan,
  // hilang saat halaman ditutup.
  const [temp, setTemp] = useState({})

  const katalog = useModelTenant()


  const referensi = useReferensi()
  // REFERENSI BRAND TERPILIH SEJAK LAYAR DIBUKA.
  //
  // Gaya brand adalah hal yang diinginkan hampir selalu, dan yang hampir selalu
  // diinginkan tidak pantas jadi langkah manual yang harus diingat tiap kali. Sebelum
  // ini daftarnya mulai KOSONG, jadi tiap gambar yang dibuat tanpa mengklik referensi
  // lahir tanpa gaya brand sama sekali — tanpa satu pun tanda bahwa ada yang terlewat.
  //
  // Lewat efek, bukan nilai awal `useState`: daftarnya datang dari jaringan dan belum
  // ada saat render pertama. `refDisemai` menjaga ia terjadi SEKALI — tanpa itu, tiap
  // penyegaran daftar akan menimpa pilihan orang.
  useEffect(() => {
    if (refDisemai || !referensi.data) return
    setRefDisemai(true)
    const bawaan = refBawaan(referensi.data)
    if (bawaan.length) setRefDipakai(bawaan)
  }, [referensi.data, refDisemai])
  const ubahGbr = useUbahGambar()
  const gambar = useBuatGambar()
  const klipVideo = useBuatVideo()
  const teks = useBuatTeks()
  const promptGambar = useBuatPromptGambar()
  // BRIEF untuk penulis prompt gambar (ADR-077). Boleh kosong, tidak diingat antar-konten.
  const [brief, setBrief] = useState('')
  const [bahanDiabaikan, setBahanDiabaikan] = useState(false)
  // Apa yang BENAR-BENAR dikirim ke model penulis prompt, dari panggilan
  // terakhir. Ditampilkan terlipat di panel Gambar.
  const [dikirimPrompt, setDikirimPrompt] = useState(null)
  const unggah = useUnggahGambarKonten()
  const simpanSlide = useSimpanSlide()

  const video = k.media_type === 'video'
  const daftarModel = modelUntukJenis(katalog.data ?? [], video ? 'video' : 'photo')
  const sibuk = gambar.isPending || klipVideo.isPending || unggah.isPending
    || simpanSlide.isPending
  const galatMedia = [gambar, klipVideo, unggah, simpanSlide]
    .find((m) => m.isError)?.error?.message || null

  // Draf DISEMAI dari slide yang sekarang, bukan dari daftar kosong. Panel yang terbuka
  // kosong terbaca sebagai "gambarnya hilang", dan orang yang menekan Simpan di situ
  // akan membuang gambar yang sudah ada tanpa bermaksud begitu.
  const mulaiSunting = () => {
    setDraf(semaiDraf(slide))
    setSunting(true)
  }

  // Caption, pesan kunci, hashtag. Disemai dari yang sekarang — sama alasannya dengan
  // draf gambar: kotak yang terbuka kosong membuat orang menyimpan penghapusan.
  const [teksBuka, setTeksBuka] = useState(false)
  const [fTeks, setFTeks] = useState({ caption: '', pesan: '', tagar: '' })
  const ubahTeks = useUbahTeksKonten()
  const jadwalkan = useJadwalkanKonten()
  const hapus = useHapusKonten()
  // Konfirmasi TERPISAH dari tombolnya. Menghapus konten tidak bisa dibatalkan — angka
  // jangkauan yang sudah terkumpul ikut hilang, dan laporan yang terlanjur memakainya
  // tidak akan cocok lagi. Satu klik terlalu murah untuk akibat sebesar itu.
  const [mintaHapus, setMintaHapus] = useState(false)
  // Disemai dari jadwal yang SUDAH ada di barisnya, bukan kosong. Kotak kosong membuat
  // orang mengira draftnya memang belum punya jadwal — padahal ia punya, dan itu justru
  // yang membuat barisnya terlihat akan terbit.
  const [kapan, setKapan] = useState(() => waktuUntukIsian(k.scheduled_at))
  const mulaiTeks = () => {
    setFTeks({
      caption: k.caption || '',
      pesan: k.key_message || '',
      tagar: (k.hashtags ?? []).map((h) => String(h).replace(/^#/, '')).join(' '),
    })
    setTeksBuka(true)
  }

  return (
    <>
      <KepalaHalaman
        judul={judulKonten(k, t)}
        keterangan={t(k.scheduled_at ? 'konten.detailKeterangan' : 'konten.detailBelumJam', {
          kapan: tanggalJam(k.scheduled_at, locale),
          tujuan: anak.map((a) => a.platform || 'instagram').join(' · '),
        })}
        aksi={
          <span className="flex flex-wrap items-center gap-2">
            <Tombol jenis="sekunder" onClick={onTutup}>{t('konten.semuaKonten')}</Tombol>
            {/* HAPUS PERMANEN. Konten yang sudah tayang sebelumnya tidak bisa disentuh
                sama sekali — dan saat postingannya diturunkan dari Instagram maupun
                Facebook, barisnya tetap duduk di "Sudah tayang" dengan tautan yang
                sudah 404. */}
            <Tombol jenis="sekunder" onClick={() => setMintaHapus(true)}>
              {t('konten.hapusKonten')}
            </Tombol>
          </span>
        }
      />

      {/* KONFIRMASINYA MENYEBUT APA YANG HILANG, bukan cuma bertanya "yakin?".
          Yang hilang bukan cuma barisnya: angka jangkauan yang sudah terkumpul ikut,
          dan laporan yang terlanjur memakainya tidak akan cocok lagi. */}
      {mintaHapus && (
        <Bendera nada="bad" judul={t('konten.hapusJudul')}>
          <p>{t('konten.hapusKet', { n: anak.length })}</p>
          <span className="flex flex-wrap items-center gap-2 mt-2">
            <Tombol
              disabled={hapus.isPending}
              onClick={() => hapus.mutate(k.id, { onSuccess: onTutup })}
            >
              {hapus.isPending ? t('umum.menunggu') : t('konten.hapusIya')}
            </Tombol>
            <Tombol jenis="sekunder" onClick={() => setMintaHapus(false)}>
              {t('umum.batal')}
            </Tombol>
          </span>
          {hapus.isError && (
            <p className="m-0 mt-2 text-[12px] text-bad">{hapus.error?.message}</p>
          )}
        </Bendera>
      )}

      <Kolom2>
        <div className="flex flex-col gap-3.5">
          <Panel
            judul={t('konten.insightJudul')}
            catatan={t('konten.insightCatatan')}
            aksi={
              <span className="flex items-center gap-2">
                {anak.length > 1 && (
                  <Seg
                    nilai={platform}
                    set={setPlatform}
                    daftar={anak.map((a) => ({
                      id: a.platform || 'instagram',
                      label: singkatPlatform(a.platform),
                    }))}
                  />
                )}
                {/* DIAMBIL ATAS PERMINTAAN, bukan tiap halaman dibuka. Tiap penekanan
                    dua panggilan Graph, dan kuotanya kuota yang sama yang dipakai
                    MENERBITKAN — halaman yang menembak Meta tiap kali dibuka akan
                    menghabiskannya, dan yang kalah penerbitan. */}
                <Tombol
                  kecil
                  jenis="sekunder"
                  disabled={!bisaSegarkan || segarkan.isPending}
                  onClick={() => segarkan.mutate(kini.id)}
                >
                  {segarkan.isPending ? t('konten.mengambil') : t('konten.perbaruiAngka')}
                </Tombol>
              </span>
            }
          >
            {/* Kisi angka, bukan tabel: enam angka pendek yang dibaca sekilas, dan tabel
                untuk itu cuma menambah garis tanpa menambah keterangan. */}
            <div className="grid gap-px bg-line
                            [grid-template-columns:repeat(auto-fit,minmax(112px,1fr))]">
              {[
                ['jangkauan', kini?.jangkauan],
                ['tayangan', kini?.tayangan],
                ['suka', kini?.suka],
                ['simpan', (kini?.lain ?? {}).simpanan],
                ['dibagikan', (kini?.lain ?? {}).dibagikan],
                ['komentar', kini?.komentar],
              ].map(([kunci, nilai]) => (
                <div key={kunci} className="bg-surface px-3.5 py-3 flex flex-col gap-0.5">
                  <span className="text-[11px] font-semibold uppercase tracking-[.06em]
                                   text-ink3">
                    {t(`konten.m.${kunci}`)}
                  </span>
                  <b className="text-[19px] tabular leading-tight">
                    {angkaAtauKosong(nilai, locale)}
                  </b>
                </div>
              ))}
            </div>

            {segarkan.isError && (
              <Body className="border-t border-line">
                {/* LEWAT PENERJEMAH YANG SAMA dengan tabel gagal terbit. Tanpa ini
                    yang muncul JSON mentah Meta — persis keluhan yang memicu
                    `jelaskanGagal` dibuat. */}
                <Bendera nada="bad" role="alert">
                  {jelaskanGagal(segarkan.error?.message, t)
                   || t('konten.gagalTanpaSebab')}
                </Bendera>
              </Body>
            )}

            {/* KAPAN ANGKANYA DIAMBIL, di sebelah angkanya sendiri. Tanpa ini "12
                jangkauan" terbaca sebagai keadaan sekarang — padahal ia bisa saja
                diambil beberapa detik sesudah terbit, saat memang belum ada yang
                melihatnya. Yang BELUM pernah diambil mengatakannya, bukan diam. */}
            <Body className="border-t border-line">
              <Sub>
                {kini?.diambil
                  ? t('konten.diambil', { kapan: sejak(kini.diambil, locale) })
                  : t('konten.belumDiambil')}
              </Sub>
            </Body>

            <Body className="border-t border-line">
              <Sub>
                {kini?.tautan
                  ? <a href={kini.tautan} target="_blank" rel="noreferrer"
                       className="font-semibold text-accent no-underline hover:underline">
                      {t('konten.bukaPostingan')} →
                    </a>
                  : t('konten.tanpaTautan')}
              </Sub>
            </Body>
          </Panel>

          <Bendera nada="info" judul={t('konten.kenapaKosongJudul')}>
            {t('konten.kenapaKosongIsi')}
          </Bendera>

          {/* DRAFT PUNYA JADWAL, TAPI TIDAK PUNYA JALAN MENGAKTIFKANNYA — sampai
          14 September. Operator menanyakannya: "kalau jadi draft itu gimana cara
          jadwalinnya?". Panelnya ditaruh PALING ATAS di kolom ini karena itu satu-
          satunya hal yang perlu dilakukan pada sebuah draft. */}
      {(draftBelumTerjadwal(k) || menungguTanpaJam(k)) && (
        <Bendera nada="warn"
                 judul={t(menungguTanpaJam(k) ? 'konten.belumJudul' : 'konten.draftJudul')}>
          <p>{t(menungguTanpaJam(k) ? 'konten.belumKet' : 'konten.draftKet')}</p>
          <span className="flex flex-wrap items-end gap-2 mt-2">
            <label className="flex flex-col gap-1">
              <span className="text-[11px] font-semibold uppercase tracking-[.06em] text-ink3">
                {t('konten.draftKapan')}
              </span>
              <Isian
                type="datetime-local"
                className="max-w-[240px]"
                value={kapan}
                onChange={(e) => setKapan(e.target.value)}
              />
            </label>
            <Tombol
              disabled={jadwalkan.isPending}
              onClick={() => jadwalkan.mutate({
                id: k.id,
                // Kosong = pakai jadwal yang SUDAH tersimpan di barisnya. Mengirim
                // string kosong akan menimpanya jadi null dan barisnya ditolak.
                scheduled_at: kapan ? new Date(kapan).toISOString() : null,
              })}
            >
              {jadwalkan.isPending ? t('umum.menyimpan') : t('konten.draftJadwalkan')}
            </Tombol>
          </span>
          {jadwalkan.isError && (
            <p className="m-0 mt-2 text-[12px] text-bad">{jadwalkan.error?.message}</p>
          )}
          {jadwalkan.isSuccess && (
            <p className="m-0 mt-2 text-[12px]">
              {jadwalkan.data?.segera_terbit
                ? t('konten.draftSegera')
                : t('konten.draftTerjadwal')}
            </p>
          )}
        </Bendera>
      )}

      {/* CAPTION BISA DISUNTING selama belum disetujui — pertanyaan operator
              14 September. Sampai hari itu ketiganya tidak bisa disentuh dari mana pun:
              rantai manual Telegram punya `update_caption`, tapi ia menulis ke DRAFT
              CAMPAIGN, sementara baris antrean menyalin captionnya saat dibuat. */}
          <Panel
            judul={t('konten.captionJudul')}
            aksi={bisaSuntingMedia(k) && !teksBuka ? (
              <Tombol kecil jenis="sekunder" onClick={mulaiTeks}>
                {t('konten.ubahTeks')}
              </Tombol>
            ) : null}
          >
            {teksBuka ? (
              <Body className="flex flex-col gap-2.5">
                <label className="flex flex-col gap-1">
                  <span className="text-[11px] font-semibold uppercase tracking-[.06em] text-ink3">
                    {t('konten.captionJudul')}
                  </span>
                  <AreaTeks baris={6} value={fTeks.caption}
                            onChange={(e) => setFTeks({ ...fTeks, caption: e.target.value })} />
                  {/* HITUNGANNYA TERLIHAT SAAT MENGETIK, bukan sesudah ditolak.
                      Batas 1800 itu tempat `build_caption` memotong diam-diam saat
                      terbit — dan yang terpotong diam-diam adalah caption yang ditinjau
                      utuh lalu tayang setengah. */}
                  <Sub className={fTeks.caption.length > 1800 ? 'text-bad' : undefined}>
                    {t('konten.captionHitung', { n: fTeks.caption.length, batas: 1800 })}
                  </Sub>
                </label>
                <label className="flex flex-col gap-1">
                  <span className="text-[11px] font-semibold uppercase tracking-[.06em] text-ink3">
                    {t('konten.pesanKunci')}
                  </span>
                  <Isian value={fTeks.pesan}
                         onChange={(e) => setFTeks({ ...fTeks, pesan: e.target.value })} />
                </label>
                <label className="flex flex-col gap-1">
                  <span className="text-[11px] font-semibold uppercase tracking-[.06em] text-ink3">
                    {t('konten.hashtag')}
                  </span>
                  <Isian value={fTeks.tagar} placeholder="asuransi kesehatan bpjs"
                         onChange={(e) => setFTeks({ ...fTeks, tagar: e.target.value })} />
                  <Sub>{t('konten.hashtagKet', { n: bacaHashtag(fTeks.tagar).length })}</Sub>
                </label>
                <span className="flex flex-wrap items-center gap-2">
                  <Tombol
                    disabled={ubahTeks.isPending || !fTeks.caption.trim()}
                    onClick={() => ubahTeks.mutate({
                      id: k.id,
                      caption: fTeks.caption.trim(),
                      key_message: fTeks.pesan.trim(),
                      hashtags: bacaHashtag(fTeks.tagar),
                    }, { onSuccess: () => setTeksBuka(false) })}
                  >
                    {ubahTeks.isPending ? t('umum.menyimpan') : t('umum.simpanPerubahan')}
                  </Tombol>
                  <Tombol jenis="sekunder" onClick={() => setTeksBuka(false)}>
                    {t('umum.batal')}
                  </Tombol>
                  <span className="text-[11px] text-ink3">{t('konten.ubahTeksKet')}</span>
                </span>
                {ubahTeks.isError && (
                  <Bendera nada="bad" role="alert">{ubahTeks.error?.message}</Bendera>
                )}
              </Body>
            ) : (
              <Body className="flex flex-col gap-2">
                <p className="m-0 text-[12.5px] whitespace-pre-wrap">
                  {k.caption || <span className="text-ink3">—</span>}
                </p>
                {k.key_message && (
                  <p className="m-0 text-[12px] text-ink2">💡 {k.key_message}</p>
                )}
                {(k.hashtags ?? []).length > 0 && (
                  <p className="m-0 font-mono text-[11.5px] text-ink3">
                    {(k.hashtags ?? []).map((h) => `#${String(h).replace(/^#/, '')}`).join(' ')}
                  </p>
                )}
              </Body>
            )}
          </Panel>
        </div>

        <Panel
          judul={t('konten.yangTayangJudul')}
          catatan={slide.length > 1
            ? t('konten.yangTayangCollase', { n: slide.length })
            : t(k.media_type === 'video' ? 'konten.yangTayangVideo'
                                         : 'konten.yangTayangFoto')}
        >
          {/* SATU SLIDE PENUH, DIGESER — bukan dua berjajar.
              Bentuk pertama menampilkan seluruh slide sekaligus dalam kisi dua kolom.
              Itu salah dua kali: tiap gambar jadi separuh lebar padahal panel ini
              satu-satunya tempat isinya bisa DILIHAT, dan susunannya tidak menyerupai
              apa pun yang dilihat orang di Instagram. Operator memintanya persis:
              "tampilannya 1 layar full, lalu bisa di-slide saja".

              SELURUH SLIDE TETAP ADA DI DOM, digeser dengan `translateX` — bukan
              ditukar satu per satu. Yang ditukar akan memuat ulang gambarnya tiap kali
              tombol ditekan, dan gambar yang belum sempat termuat menampilkan kotak
              kosong di tempat yang tadi berisi. Semuanya sudah termuat sejak awal, jadi
              pergeserannya seketika. */}
          <Body className="flex flex-col gap-2">
            <div className="overflow-hidden rounded-md border border-line">
              <div
                className="flex transition-transform duration-200 motion-reduce:transition-none"
                style={{ transform: `translateX(-${slideKe * 100}%)` }}
              >
                {slide.map((u, i) => (
                  <Gambar
                    key={u || i}
                    src={u}
                    className="w-full shrink-0 aspect-square object-cover"
                    teksHilang={t('bk.gambarHilang')}
                  />
                ))}
              </div>
            </div>

            {/* KENDALINYA HANYA MUNCUL KALAU ADA YANG BISA DIGESER. Satu foto biasa
                bukan collase satu slide, dan panah yang selalu mati di kedua ujung
                cuma menambah dua tombol yang tidak pernah berguna. */}
            {slide.length > 1 && (
              <div className="flex items-center justify-between gap-2">
                <TombolBuat
                  aria-label={t('konten.slideMundur')}
                  disabled={slideKe === 0}
                  onClick={() => setSlideKe((x) => geserSlide(x, -1, slide.length))}
                >
                  ‹
                </TombolBuat>

                {/* TITIK YANG BISA DIKLIK, bukan hiasan: sepuluh slide berarti sembilan
                    kali menekan panah untuk sampai ke yang terakhir. */}
                <span className="flex items-center gap-1.5">
                  {slide.map((u, i) => (
                    <button
                      key={u || i}
                      type="button"
                      aria-label={t('konten.slideKe', { n: i + 1, dari: slide.length })}
                      aria-current={i === slideKe}
                      onClick={() => setSlideKe(i)}
                      className={'h-2 w-2 rounded-full border-0 cursor-pointer p-0 '
                        + (i === slideKe ? 'bg-accent' : 'bg-lineStrong')}
                    />
                  ))}
                </span>

                <TombolBuat
                  aria-label={t('konten.slideMaju')}
                  disabled={slideKe === slide.length - 1}
                  onClick={() => setSlideKe((x) => geserSlide(x, 1, slide.length))}
                >
                  ›
                </TombolBuat>
              </div>
            )}

            {slide.length > 1 && (
              <Sub className="text-center">
                {t('konten.slideKe', { n: slideKe + 1, dari: slide.length })}
              </Sub>
            )}
          </Body>

          {/* MENYUNTING MEDIA SEBELUM DISETUJUI.
              Sampai 14 September tinjauan cuma punya dua jawaban: setujui atau tolak.
              Foto yang HAMPIR benar — komposisinya bagus, warnanya meleset — tidak punya
              jalan tengah sama sekali, jadi satu-satunya cara memperbaikinya adalah
              menolaknya lalu membuat ulang seluruh konten dari nol.

              Di sinilah juga konten satu gambar berubah jadi collase: menambah slide
              tidak menuntut slotnya digenerate ulang. */}
          {/* MENYUNTING MEDIA SEBELUM DISETUJUI.
              Sampai 14 September tinjauan cuma punya dua jawaban: setujui atau tolak.
              Foto yang HAMPIR benar tidak punya jalan tengah sama sekali, jadi
              satu-satunya cara memperbaikinya adalah menolaknya lalu membuat ulang
              seluruh konten dari nol. */}
          {bisaSuntingMedia(k) && !sunting && (
            <Body className="border-t border-line flex flex-wrap items-center gap-2">
              <Tombol kecil jenis="sekunder" onClick={mulaiSunting}>
                {t('konten.suntingMedia')}
              </Tombol>
              <span className="text-[11px] text-ink3">{t('konten.suntingMediaKet')}</span>
            </Body>
          )}

          {bisaSuntingMedia(k) && sunting && (
            <Body className="border-t border-line flex flex-col gap-3">
              {/* PANEL YANG SAMA PERSIS dengan layar Buat Konten — bukan salinannya. */}
              <PanelGambar
                slide={draf}
                setSlide={setDraf}
                daftarModel={daftarModel}
                model={model}
                setModel={setModel}
                video={video}
                referensi={referensi}
                refDipakai={refDipakai}
                temp={temp}
                setTemp={setTemp}
                      setRefDipakai={setRefDipakai}
                sedangBuat={gambar.isPending || klipVideo.isPending}
                galat={(video ? klipVideo : gambar).error?.message}
                bisaPrompt={Boolean((k.caption || '').trim())}
                dikirimPrompt={dikirimPrompt}
                brief={brief}
                setBrief={setBrief}
                bahanDiabaikan={bahanDiabaikan}
                dikirimPrompt={dikirimPrompt}
                sedangPrompt={promptGambar.isPending}
                buatPrompt={async () => {
                  // SATU PANGGILAN untuk SEMUA slide (ADR-077) — slide harus maju
                  // berurutan, dan panggilan terpisah menghasilkan adegan tak berhubungan.
                  const r = await promptGambar.mutateAsync({
                    caption: k.caption || '',
                    key_message: k.key_message || '',
                    brief,
                    slide: draf.length,
                    bahan: bentukBahan(refDipakai, temp),
                  })
                  const daftar = r?.prompt ?? []
                  setDraf((x) => x.map((sl, j) => ({ ...sl, prompt: (daftar[j] || '').trim() })))
                  if (r?.referensi?.length) setRefDipakai(r.referensi)
                  setDikirimPrompt(r?.dikirim || null)
                  setBahanDiabaikan(Boolean(r?.bahan_diabaikan))
                }}
                unggahSlide={async (berkas) =>
                  unggah.mutateAsync({ id: k.id, berkas })}
                buatGambar={async (i, rasio) => {
                  // SATU TOMBOL, DUA RUTE — jenis kontennya yang menentukan, sama
                  // seperti di Buat Konten.
                  const r = video
                    ? await klipVideo.mutateAsync({
                      prompt: draf[i].prompt.trim(), model: model || null })
                    : await gambar.mutateAsync({
                      prompt: draf[i].prompt.trim(), model: model || null,
                      bahan: bentukBahan(refDipakai, temp), aspect_ratio: rasio })
                  // DICATAT, BUKAN DITIMPA. Hasil sebelumnya tetap di deretan
                  // supaya bisa dipilih lagi — lihat `catatHasil`.
                  setDraf((x) => catatHasil(x, i, {
                    url: (video ? r?.video_url : r?.image_url) || '',
                    tiket: r?.sumber_tiket ?? null,
                    biaya: r?.cost_estimate_usd != null
                      ? `${r.model_used} · $${r.cost_estimate_usd.toFixed(4)}`
                      : r?.model_used,
                  }))
                }}
                ubahGambar={async (i, teks) => {
                  // Gambar terpilih + teks Ubah. Referensi brand dan prompt slide
                  // SENGAJA tidak ikut — lihat `bentukUbah`.
                  const r = await ubahGbr.mutateAsync(bentukUbah(draf, i, teks, model))
                  setDraf((x) => catatHasil(x, i, {
                    url: r?.image_url || '',
                    tiket: r?.sumber_tiket ?? null,
                    biaya: r?.cost_estimate_usd != null
                      ? `${r.model_used} · $${r.cost_estimate_usd.toFixed(4)}`
                      : r?.model_used,
                  }))
                }}
              />

              {galatMedia && <Bendera nada="bad" role="alert">{galatMedia}</Bendera>}

              <span className="flex flex-wrap items-center gap-2">
                <Tombol
                  disabled={sibuk || !draf.some((x) => x.url)}
                  onClick={() => simpanSlide.mutate(
                    { id: k.id, urls: draf.map((x) => x.url).filter(Boolean) },
                    { onSuccess: () => setSunting(false) })}
                >
                  {simpanSlide.isPending ? t('umum.menyimpan') : t('konten.simpanGambar')}
                </Tombol>
                <Tombol jenis="sekunder" disabled={sibuk} onClick={() => setSunting(false)}>
                  {t('umum.batal')}
                </Tombol>
                <span className="text-[11px] text-ink3">{t('konten.simpanGambarKet')}</span>
              </span>
            </Body>
          )}

          {/* TIAP TUJUAN PUNYA BARISNYA SENDIRI di sini, termasuk yang gagal. Panel di
              kiri cuma menampilkan yang sedang dipilih; daftar ini yang menjawab "ke mana
              saja sebenarnya ia terbit". */}
          <Body className="border-t border-line">
            <KV>
              {anak.map((a) => (
                <KVBaris key={a.id} label={a.platform || 'instagram'}>
                  <span className="flex flex-wrap items-center gap-2">
                    <Chip nada={NADA[a.status] ?? 'idle'}>{istilah(t, 'st', a.status)}</Chip>
                    {/* YANG TIDAK PUNYA TAUTAN MENGATAKANNYA. Baris yang diam tidak
                        bisa dibedakan dari baris yang tautannya lupa ditampilkan — dan
                        yang membacanya menyimpulkan layarnya yang rusak. */}
                    {a.tautan ? (
                      <a href={a.tautan} target="_blank" rel="noreferrer"
                         className="text-[11.5px] font-semibold text-accent no-underline
                                    hover:underline">
                        {t('konten.lihatPostingan')}
                      </a>
                    ) : (
                      <span className="text-[11px] text-ink3">{t('konten.tanpaTautan')}</span>
                    )}
                  </span>
                </KVBaris>
              ))}
              <KVBaris label={t('konten.kolJenis')}>
                {k.media_type === 'video' ? t('bk.video') : t('bk.foto')}
              </KVBaris>
              {k.topic && (
                <KVBaris label={t('konten.sumberIde')}>
                  <span className="text-[12px]">{k.topic}</span>
                </KVBaris>
              )}
            </KV>
          </Body>
        </Panel>
      </Kolom2>
    </>
  )
}
